/** Кто стоит за adamar.app — на юр. страницах и в подвале каждой страницы.
 *
 *  С 30.10.2026 оператор — ИП Ли Алексей Юрьевич (решение владельца): AdaMar
 *  переехал в бизнес-портфолио Meta «Aleksei Li», где уже Doctor Kana и
 *  Jazuu, а Meta сверяет «сайт ↔ юрлицо» по названию. Поэтому название —
 *  ровно как на doctor-kana.org и jazuu.org; иначе для Meta это две
 *  организации. Адрес — только город: юр. адрес ИП — домашний адрес
 *  владельца, на открытой странице ему делать нечего. ИНН сюда не писать —
 *  у физлица в нём дата рождения.
 *
 *  Название склоняется («Индивидуальному предпринимателю…»), а подставляется
 *  как есть: в тексте ставить его только в именительном — «Оператор —
 *  {name}», а не «принадлежат {name}». У «ОсОО «AdaMar»» падежа не было,
 *  и эта ловушка не была видна. */
export const LEGAL_ENTITY = {
  name: 'Индивидуальный предприниматель Ли Алексей Юрьевич',
  address: 'Кыргызская Республика, г. Бишкек',
  email: 'info@adamar.app',
};
